import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import RequireAuth from './RequireAuth';
import Dashboard from './page/Dashboard';
import UserList from './page/UserList';
import StoreList from './page/StoreList';
import PostModeration from './page/PostModeration';
import StoreImport from './page/StoreImport';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        <Route element={<RequireAuth />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/stores" element={<StoreList />} />
          <Route path="/posts/moderation" element={<PostModeration />} />
          <Route path="/import/stores" element={<StoreImport />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
